import { render } from "./PunishmentTransactionForm.vue?vue&type=template&id=27bcc44b&scoped=true"
import script from "./PunishmentTransactionForm.vue?vue&type=script&lang=js"
export * from "./PunishmentTransactionForm.vue?vue&type=script&lang=js"

import "./PunishmentTransactionForm.vue?vue&type=style&index=0&id=27bcc44b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bcc44b"]])

export default __exports__